<template>
  <div class="send flex w-full justify-between items-center px-2">
    <div class="flex w-full comment flex-row items-center chatbox m-1 mr-2  ">
      <textarea
        :value="value"
        ref="chatArea"
        @change="emitValue($event)"
        @input="
          emitValue($event);
          resize();
        "
        @keydown.enter.exact="emitEnter"

        placeholder="Type your comment"
        class="text-bold ml-4   w-full text-grey-500 px-1 "
        type="text"
        rows="2"
      >
      </textarea>
      <div class="comment">
        <button
          @click="$emit('send', $event)"
          class="flex justify-center send position-sticky"
        >
          <i class="far mt-4 text-white fa-paper-plane"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import axios from "axios";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  props: {
    value: {
      required: false,
    },
  },
  data() {
    return {
      picker: "",
      dialog: false,
      data: {},
      dropzoneOptions: {
        acceptedFiles: "image/*",
        url: "http://localhost:8000/api/image",
        maxFilesize: 5, // MB
        maxFiles: 1,
        chunking: true,
        preventDuplicates: true,
        chunkSize: 500, // Bytes
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictDefaultMessage: `<i class='fa fa-file-image-o' style='font-size:100px; text-align: center'></i>
      <br> Upload Display Image  <span style='color: red'>Upload</span>`,
      },
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  watch: {
    value: function(newVal, oldVal) {
      if (newVal == "") {
        this.$refs.chatArea.style.height = `55px`;
      }
    },
  },
  methods: {
    async save() {
      const formData = new FormData();
      //console.log({ hhhh: this.data });
      formData.append("file", this.data.file);
      formData.append("upload_preset", "xqsyhkma");
      const endpoint = `https://api.cloudinary.com/v1_1/lms-edc/image/upload`;
      try {
        const res = await axios.post(endpoint, formData, {
          headers: {
            "content-type": "multipart/form-data",
          },
        });

        if (res.status == 200) {
          let content = res.data.secure_url;
          this.sendMessage(content);
        }
      } catch (e) {
        //console.log(e);
        // return false
      }
    },
    async afterComplete(upload) {
      this.file = upload;
      this.data.file = upload;
    },
    // async uploadFile() {
    //   let formData = new FormData();
    //   formData.append("upload_file", this.data.file);
    //   axios
    //     .post(`${this.$baseUrl}/saveFile`, formData)
    //     .then((response) => {
    //       //console.log({ response });
    //     })
    //     .catch((error) => {
    //       self.loading = false;
    //       self.error = true;
    //       let err_msg = error.response.data
    //         ? error.response.data.message
    //         : "An error occured";
    //       self.$swal("Error!", err_msg, "error");
    //     });
    // },
    sendMessage(content) {
      axios
        .post(
          `${this.$baseUrl}/business/request/messages/${this.$route.params.id}`,
          { message: content },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("cerebro-token")}`,
            },
          }
        )
        .then(() => {
          this.dialog = false;
        })
        .catch(() => {});
    },
    emitEnter(e) {
      e.preventDefault();
      this.$emit("keyup");
    },
    emitValue(e) {
      this.$emit("input", e.target.value);
    },
    resize() {
      if (this.$refs.chatArea.value == "") {
        this.$refs.chatArea.style.height = `55px`;
      }
      let h = parseInt(this.$refs.chatArea.scrollHeight, 10);
      if (h < 150) {
        this.$refs.chatArea.style.height = `auto`;
        this.$refs.chatArea.style.height = `${this.$refs.chatArea.scrollHeight}px`;
        return;
      } else if (h > 150) {
        this.$refs.chatArea.style.height = `150px`;
      }
    },
  },
  mounted() {
    // this.picker.on("emoji", (emoji) => {
    //   let chatArea = this.$refs.chatArea;
    //   let cursorPosition = chatArea.selectionEnd;
    //   let currentChat = chatArea.value;
    //   let start = currentChat.substring(0, chatArea.selectionStart);
    //   let end = currentChat.substring(chatArea.selectionStart);
    //   chatArea.value = `${start}${emoji}${end}`;
    //   chatArea.focus();
    //   this.$nextTick(() => {
    //     chatArea.selectionEnd = cursorPosition + emoji.length;
    //   });
    //   this.$emit("input", chatArea.value);
    // });
  },
};
</script>
<style lang="scss" scoped>
.send {
  .chatbox {
    border-radius: 30px;
    background-color: #f4f4f4;

    textarea {
      max-height: 28px;
      border-radius: 30px;
      resize: none;
      font-size: 14px;
      background-color: #f4f4f4;
      border: none;
      padding-top: 1rem;
      font-family: "Open sans";

      &:focus {
        outline: none;
      }
    }
  }

  button {
    background-color: color(bv-primary);
    border-radius: 50%;
    height: 48px;
    width: 48px;
    &:focus {
      outline: none;
    }
  }
}
.comment {
  button {
    background-color: #0087db;
    border-radius: 50%;
    border: none;
    height: 43px;
    width: 43px;
    &:focus {
      outline: none;
    }
  }
}
.width- {
  &25 {
    width: 25% !important;
  }
  &50 {
    width: 50% !important;
  }
  &100 {
    width: 100% !important;
  }
  &auto {
    width: auto !important;
  }
  &fit-content {
    width: fit-content !important;
  }
  &fill-screen {
    width: 100vh !important;
  }
}
</style>
